import { buildContentQuery } from './Content'
import { FAIL_FETCH } from './Other'
export const FETCH_IMPRESSION_STATS = 'FETCH_IMPRESSION_STATS'
export const LOAD_IMPRESSION_STATS = 'LOAD_IMPRESSION_STATS'
/**
 * fetchImpressionStats
 * @desc generate a fetch action for impression stats
 * @param {string} accountId account ID
 * @param {string} startDate start date
 * @param {string} endDate end date
 * @param {Object} options additional query options
 * @return {action} action
 */
export function fetchImpressionStats (accountId, startDate, endDate, options = {}) {
  let query = { accountId, startDate, endDate }
  query = buildContentQuery(query, options)
  if (query.accountId) {
    return { type: FETCH_IMPRESSION_STATS, query }
  }
  return { type: FAIL_FETCH, query }
}

/**
 * loadImpressionStats
 * @desc Load impression stats result
 * @param {Object} data data to load
 * @return {action} loadImpressionStatsAction
 */
export function loadImpressionStats (data) {
  return {
    type: LOAD_IMPRESSION_STATS,
    data
  }
}
